import type { UseExploreItemsParams } from '../api/exploreParams'

export const all = ['tripExplore'] as const
export const items = (params: UseExploreItemsParams) =>
  [...all, 'items', params] as const
